export default [
  {
    type: 'data engineering',
    content: [
      'Databricks',
      'Snowflake',
      'Airflow',
      'Spark',
      'PySpark',
      'Hadoop',
      'ETL',
      'ELT',
      'Database Modeling',
      'PostgreSQL',
      'SSMS',
      'SSIS',
      'SSRS',
      'SSO',
    ],
  },
  {
    type: 'cloud',
    content: [
      'Azure Databricks',
      'Microsoft Fabric',
      'Azure Synapse Analytics',
      'Azure Data Factory',
      'Entra ID',
      'AWS Redshift',
      'AWS S3',
      'AWS EC2',
      'DynamoDB',
      'AWS Lambda',
      'IAM',
      'QuickSight',
      'Google BigQuery',
    ],
  },
  {
    type: 'programming',
    content: ['SQL', 'Python', 'PySpark'],
  },
  {
    type: 'data visualization',
    content: ['Power BI', 'Metabase', 'Tableau', 'Domo'],
  },
  {
    type: 'devops',
    content: ['Git', 'Docker', 'Kubernetes', 'Azure DevOps', 'GitHub Actions'],
  },
  {
    type: 'platforms',
    content: ['Linux', 'macOS', 'Windows'],
  },
  {
    type: 'tools',
    content: [
      'Microsoft Office 365',
      'Slack',
      'Teams',
      'Zoom',
      'Lucidchart',
    ],
  },
] satisfies SkillsGroup[];
